import createIcon from '../../createIcon';

/**
 * @component @name MoreHoriz
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNiAxMEM0LjkgMTAgNCAxMC45IDQgMTJDNCAxMy4xIDQuOSAxNCA2IDE0QzcuMSAxNCA4IDEzLjEgOCAxMkM4IDEwLjkgNy4xIDEwIDYgMTBaTTE4IDEwQzE2LjkgMTAgMTYgMTAuOSAxNiAxMkMxNiAxMy4xIDE2LjkgMTQgMTggMTRDMTkuMSAxNCAyMCAxMy4xIDIwIDEyQzIwIDEwLjkgMTkuMSAxMCAxOCAxMFpNMTIgMTBDMTAuOSAxMCAxMCAxMC45IDEwIDEyQzEwIDEzLjEgMTAuOSAxNCAxMiAxNEMxMy4xIDE0IDE0IDEzLjEgMTQgMTJDMTQgMTAuOSAxMy4xIDEwIDEyIDEwWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MoreHoriz = createIcon('MoreHoriz', [
  [
    'path',
    {
      d: 'M6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z',
      key: 'axpa9z',
    },
  ],
]);

export default MoreHoriz;
